import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import React, { useEffect, useRef, useState } from "react";
import { Loading } from "Components";
import NavBar from "ProfileComponents/Navigation/NavBar";
import { OrderBox, TopRightX, OrderDetails, TranslucentNavbar } from "ProfileComponents";
import { useDispatch, useSelector } from "react-redux";
import { setNavBarVisible, setNextIndexAction, setIsCompleteAction, setOrdersAction, setThisOrderDetailAction, setFetchingMoreAction, setHistoryStoreAction, setGlobalLoading, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
import { fetchOrdersHistoryThunk, fetchMoreOrdersThunk, } from "../../redux/thunkCreators/orderHistory/orderHistoryThunk";
import styles from "./styles.module.scss";
import FutureOrders from "../SubscriptionPageV2/NextFutureOrders/FutureOrders";
import { useLocation } from "react-router";
import H2Font from "../common/H2Font";
const defaultOrderData = {
    Items: [],
    ORDER_ID: "0",
    PAYMENT_METHOD: [],
    SHIPPING_ADDRESS: [],
    TOTAL_PRICE: "",
    orderDate: "",
    orderStatus: "",
    pricing_summary: [],
    DISCOUNT: "",
    FLAT_ITEMS: [],
    ORDER_NUM: 0,
    NEEDS_TO_SET: false,
    PASSWORD_SET: "",
    SHIPPING_COST: "",
    SHIPPING_SPEED: "",
    TAX: "",
    DELIVERYDATE: "",
    tracking_url: "",
};
function OrderHistory() {
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.history);
    const reduxOrders = useSelector((state) => state.orderHistory.orders);
    const reduxIsComplete = useSelector((state) => state.orderHistory.isComplete);
    const reduxFetchingMore = useSelector((state) => state.orderHistory.fetchingMore);
    const reduxNextIndex = useSelector((state) => state.orderHistory.nextIndex);
    const user = useSelector((state) => state.user);
    const reduxThisOrderDetail = useSelector((state) => state.orderHistory.thisOrderDetail);
    const { nav_visibility } = useSelector((state) => state.components);
    const [inOrderDetails, _setInOrderDetails] = useState(false);
    const [isActiveOrderHistory, setIsActiveOrderHistory] = useState(true);
    const { hash } = useLocation();
    const myStateRef = React.useRef(inOrderDetails);
    const setInOrderDetails = (data) => {
        myStateRef.current = data;
        _setInOrderDetails(data);
    };
    const dispatch = useDispatch();
    const isMobile = useScreenWidth() < 768;
    // useRef is needed in order to access the current state in the event listener
    // Otherwise it will always get use what the state was upon initialization
    // see https://stackoverflow.com/questions/55265255/react-usestate-hook-event-handler-using-initial-state for details
    // define a ref
    const nextIndexReduxRef = useRef(reduxNextIndex);
    const isCompleteReduxRef = useRef(reduxIsComplete);
    const fetchingMoreReduxRef = useRef(reduxFetchingMore);
    const ordersReduxRef = useRef(reduxOrders);
    // in place of original `setNextIndex`
    const setNextIndex = (x) => {
        nextIndexReduxRef.current = x; // keep updated
        dispatch(setNextIndexAction(x));
    };
    // in place of original `setFetchingMore`
    const setFetchingMore = (x) => {
        fetchingMoreReduxRef.current = x; // keep updated
        dispatch(setFetchingMoreAction(x));
    };
    // in place of original `setIsComplete`
    const setIsComplete = (x) => {
        isCompleteReduxRef.current = x; // keep updated
        dispatch(setIsCompleteAction(x));
    };
    // in place of original `setOrders`
    const setOrders = (x) => {
        ordersReduxRef.current = x; // keep updated
        dispatch(setOrdersAction(x));
    };
    const fetchOrderData = async () => {
        dispatch(setGlobalLoading(true));
        await dispatch(fetchOrdersHistoryThunk(setOrders, setIsComplete, setNextIndex));
        dispatch(setHistoryStoreAction(false));
        dispatch(setGlobalLoading(false));
    };
    const fetchNextBatch = () => {
        const footerHeight = isMobile ? 800 : 513;
        if (!isCompleteReduxRef.current && !fetchingMoreReduxRef.current && !myStateRef.current) {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight) {
                setFetchingMore(true);
                dispatch(fetchMoreOrdersThunk(setOrders, setIsComplete, setNextIndex, setFetchingMore, nextIndexReduxRef.current, ordersReduxRef.current));
            }
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        if (reduxStoreIsEmpty) {
            fetchOrderData();
        }
        if (["future_orders"].includes(hash.replace("#", ""))) {
            setIsActiveOrderHistory(false);
        }
        window.addEventListener("scroll", fetchNextBatch);
    }, []);
    function exitOrderDetails() {
        dispatch(setThisOrderDetailAction({ ...defaultOrderData }));
        dispatch(setNavBarVisible(true));
        setInOrderDetails(false);
    }
    function showOrderDetails(orderIndex) {
        window.scrollTo(0, 0);
        const thisOrderData = reduxOrders[orderIndex];
        dispatch(setNavBarVisible(false));
        dispatch(setThisOrderDetailAction(thisOrderData));
        setInOrderDetails(true);
    }
    return (_jsxs(_Fragment, { children: [nav_visibility && _jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true }), reduxThisOrderDetail.ORDER_ID !== "0" ? (_jsxs(_Fragment, { children: [_jsx(TopRightX, { onClick: () => exitOrderDetails() }), _jsx(OrderDetails, { orderNumber: reduxThisOrderDetail.ORDER_ID, items: reduxThisOrderDetail.Items, orderDate: reduxThisOrderDetail.orderDate, status: reduxThisOrderDetail.orderStatus, pricingSummary: reduxThisOrderDetail.pricing_summary, shippingAddress: reduxThisOrderDetail.SHIPPING_ADDRESS, paymentMethod: reduxThisOrderDetail.PAYMENT_METHOD, goBack: () => exitOrderDetails() })] })) : (_jsxs(_Fragment, { children: [isMobile && _jsx(TranslucentNavbar, { animated: true, className: styles["order-navbar"], text: "Your Orders" }), _jsxs("div", { className: `${styles["profile-container"]} ${styles["order-history-page"]}`, children: [_jsx(H2Font, { children: "Your Orders" }), _jsx("div", { className: styles.tabs_wrapper, children: _jsx("div", { role: "button", tabIndex: 0, onKeyDown: () => null, onClick: () => setIsActiveOrderHistory(false), className: "profile-navigation__link", "data-attr": "future-orders-button", children: user.has_subscription && user.showFutureOrderToggles && (_jsx("span", { className: `${!isActiveOrderHistory ? styles.active_link : ""} profile-navigation__link-name navigation__span`, children: "Future Orders" })) }) }), reduxOrders.length === 0 ? (_jsx(Loading, {})) : isActiveOrderHistory ? (_jsx(_Fragment, { children: reduxOrders.map((orderData, i) => (_jsx(OrderBox, { orderNumber: orderData.ORDER_ID, orderDate: orderData.orderDate, status: orderData.orderStatus, trackingUrl: orderData.tracking_url, pricingSummary: orderData.pricing_summary, items: orderData.Items, totalPrice: orderData.TOTAL_PRICE, detailsClick: () => showOrderDetails(i) }, `${orderData.Items.map((item) => item.title).join(`${i}`)} ${orderData.orderDate}`))) })) : (_jsx(_Fragment, { children: user.has_subscription && _jsx(FutureOrders, { extraClassName: "order-history-future-orders" }) })), reduxFetchingMore && _jsx(Loading, {})] })] }))] }));
}
export default OrderHistory;
